export const getContractType = (contractType) => {
  const isErc404 = contractType === 'ERC404';
  const isErc721 = contractType === 'ERC721';
  const isErc1155 = contractType === 'ERC1155';
  const isDn404 = contractType === 'DN404';
  return { isErc404, isErc721, isErc1155, isDn404 };
};
